export default __webpack_public_path__ + "images/sv-3bb132d79aef68d7fe4173688648ef29.svg";